module.exports = __webpack_public_path__ + "static/media/palms-right.12993316.png";